import { render, staticRenderFns } from "./SocketLoadTester.vue?vue&type=template&id=487c7689&scoped=true&"
import script from "./SocketLoadTester.vue?vue&type=script&lang=js&"
export * from "./SocketLoadTester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c7689",
  null
  
)

export default component.exports